import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ENV } from '../../../config/config';
import FullPageLoader from 'components/FullPageLoader/FullPageLoader';
import Swal from 'sweetalert2';
import validator from 'validator';
import { useAddStaffAdminMutation, useUpdateAdminMutation } from '../../../redux/api';

import Select from 'react-select'
import { Button, Card, Form, Table, Container, Row, Col, OverlayTrigger, Tooltip, Modal, FormGroup } from "react-bootstrap";
import { validateName } from 'utils/validations/validations';
var CryptoJS = require("crypto-js");

const StaffPermissionModal = (props) => {

    const [addStaffAdmin, { isLoading: isAddingStaff }] = useAddStaffAdminMutation();
    const [updateAdmin, { isLoading: isUpdatingStaff }] = useUpdateAdminMutation();
    const [userId, setUserId] = useState('')
    const [roleId, setRoleId] = useState(0)
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [admin, setAdmin] = useState('')
    const [isActive, setIsActive] = useState(1)
    const [password, setPasssword] = useState('')
    const [confirmPassword, setConfirmPass] = useState('')
    const [photo, setPhoto] = useState()
    const [image, setImage] = useState()
    // const [showPassword, setShowPassword] = useState(false)
    const [adminPassword, setAdminPassword] = useState('')
    // const [selectedUserPassword, setSelectedUserPass] = useState('')
    // const [adminPasswordVerified, setPasswordVerified] = useState(false)
    // const [staff, setStaff] = useState({
    //     fullName: '',
    //     roleId: '',
    //     email: '',
    //     phone: '',

    // })


    const [roles, setRoles] = useState({})
    // const [role, setRole] = useState({})
    const [rolesOptions, setOptions] = useState([])
    // const [phone, setPhone] = useState('')
    const [nameMsg, setNameMsg] = useState('')
    const [emailMsg, setEmailMsg] = useState('')
    const [passwordMsg, setPassMsg] = useState('')
    const [roleMsg, setRoleMsg] = useState('')
    const [confirmPassMsg, setConfirmPassMsg] = useState('')
    const [adminPasswordMsg, setAdminPasswordMsg] = useState('')
    const [photoMsg, setPhotoMsg] = useState('')
    const [formValid, setFormValid] = useState(false)




    useEffect(() => {}, [])

    useEffect(() => {}, [])

    useEffect(() => {
        if (Object.keys(props.admin).length > 0) {
            if (props.modalType === 1) {
                setEmpty()
            }
            else if (props.modalType === 2 || props.modalType === 3) {
                setUserId(props.admin.id)
                setFirstName(props.admin.firstName)
                setLastName(props.admin.lastName)
                // setRole(props.admin.role.title)
                setRoleId(Number(props.admin.roleId))
                setEmail(props.admin.email)
                setPhoto(props.admin.photo)
                setIsActive(props.admin.isActive)
                setPasssword('')
            }

        }
    }, [props.admin, props.flag])

    useEffect(() => {
        if (props.roles) {
            setRoles(props.roles)
            let options = []
            if (props.roles?.length) {
                props.roles.map((r) => {
                    options.push({ value: r.id, label: r.title })
                })
            }
            setOptions(options)
        }
    }, [props.roles])

    const setEmpty = () => {
        setFirstName('')
        setLastName('')
        setRoleId('')
        setEmail('')
        setPasssword('')
        setConfirmPass('')
        setPhoto('')
        setImage(undefined)
        setIsActive(1)
        setPhotoMsg('')
        setNameMsg('')
        setRoleMsg('')
        setEmailMsg('')
        setPassMsg('')
        setConfirmPassMsg('')
        setAdminPasswordMsg('')
    }

    const validateFirstName = () => {
        if (validator.isEmpty(firstName)) {
            setNameMsg('This field is Required.');
            return false;
        } else {
            setNameMsg('');
            return true;
        }
    };

    const validateRoleId = () => {
        if (!roleId) {
            setRoleMsg('Please select a role');
            return false;
        } else {
            setRoleMsg('');
            return true;
        }
    };

    const validateEmail = () => {
        if (!email) {
            setEmailMsg('This field is Required.');
            return false;
        } else if (!validator.isEmail(email)) {
            setEmailMsg('Please enter a valid email address');
            return false;
        } else {
            setEmailMsg('');
            return true;
        }
    };

    const validatePassword = () => {
        if (!password && props.modalType !== 3) {
            setPassMsg('This field is Required.');
            return false;
        } else {
            setPassMsg('');
            return true;
        }
    };

    const validateConfirmPassword = () => {
        if (!confirmPassword && props.modalType !== 3) {
            setConfirmPassMsg('This field is Required.');
            return false;
        } else if (!validator.equals(password, confirmPassword) && props.modalType !== 3) {
            setConfirmPassMsg('Passwords do not match');
            return false;
        } else {
            setConfirmPassMsg('');
            return true;
        }
    };


    const submit = (e) => {
        let isValid = true;

        isValid &= validateFirstName();
        isValid &= validateRoleId();
        isValid &= validateEmail();
        if (props.modalType !== 3) {
            isValid &= validatePassword();
            isValid &= validateConfirmPassword();
        }

        if (isValid) {
            setFormValid(false);

            let formData = new FormData();
            formData.append('firstName', firstName)
            formData.append('lastName', lastName)
            formData.append('email', email)
            formData.append('isActive', isActive)
            formData.append('roleId', roleId)
            if (photo)
                formData.append('photo', photo)

            if (props.modalType === 1) { // Add modal type
                formData.append('password', password)
                addStaffAdmin(formData);
                props.setroleModal(!props.roleModal);
            } else if (props.modalType === 3) { // Update modal type
                formData.append('id', userId);
                if (!validator.isEmpty(password)) {
                    let checkPwd = true;
                    if (validator.isEmpty(confirmPassword)) {
                        setConfirmPassMsg('This field is Required.');
                        checkPwd = false;
                    } else if (!validator.equals(password, confirmPassword)) {
                        setConfirmPassMsg('Passwords do not match');
                        checkPwd = false;
                    }
                    else if (validator.isEmpty(adminPassword)) {
                        setAdminPasswordMsg("Admin Password is required for updating user passwrord.");
                        checkPwd = false;
                    }
                    else {
                        setConfirmPassMsg('');
                    }
                    if (checkPwd) {
                        formData.append("password", password);
                        formData.append("adminPassword", adminPassword);
                        updateAdmin(formData);
                        props.setroleModal(!props.roleModal);
                    }
                }
                else {
                    updateAdmin(formData);
                    props.setroleModal(!props.roleModal);
                }
            }
        } else {
            if (document.getElementById('admin-modal')) {
                document.getElementById('admin-modal').scrollTop = 0;
            }
            setFormValid(true);
        }
    }

    const onCloseHandler = () => {
        props.setroleModal(!props.roleModal)
        setEmpty()
    }

    // const onFileChange = (e) => {
    //     let file = e.target.files[0]
    //     if (file) {
    //         let reader = new FileReader();
    //         reader.readAsDataURL(file)
    //         reader.onload = function (e) {
    //             let result = e.target.result
    //             setImage(result)
    //             setPhoto(file)

    //         }
    //     }
    // }
    const onFileChange = (e) => {
        let file = e.target.files[0]
        if (file) {
            const acceptedExtensions = [".png", ".jpeg", ".jpg"];
            const fileExtension = file.name.split('.').pop();
            if (!acceptedExtensions.includes(fileExtension)) {
                setPhotoMsg("Invalid file type. Only .png, .jpeg, .jpg files are allowed.")
                return;
            }
            let reader = new FileReader();
            reader.readAsDataURL(file)
            reader.onload = function (e) {
                let result = e.target.result
                setImage(result)
                setPhoto(file)
            }
        }
    }

    return (
        <Container fluid>
            {/* {
                formValid ?
                    <div className="text-danger">Please fill the required fields</div> : null
            } */}
            {
                props.modalType > 0 &&
                <Modal className="modal-primary" id="admin-modal" onHide={() => onCloseHandler()} show={props.roleModal}>
                    <Modal.Header className="justify-content-center">
                        <Row>
                            <div className="col-12">
                                <h4 className="mb-0 mb-md-3 mt-0">
                                    {props.modalType === 1 ? 'Add New' : props.modalType === 2 ? 'View' : 'Edit'} Staff Role
                                </h4>
                            </div>
                        </Row>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <Form>
                            <Form.Group>
                                <label className="">First Name <span className="text-danger">*</span></label>
                                <Form.Control
                                    placeholder="Enter name"
                                    disabled={props.modalType === 2}
                                    type="text"
                                    name="name"
                                    onChange={(e) => setFirstName(e.target.value)}
                                    value={firstName}
                                    required
                                />
                                <span className={nameMsg ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">{nameMsg}</label>
                                </span>
                            </Form.Group>
                            <Form.Group>
                                <label className="">Last Name </label>
                                <Form.Control
                                    placeholder="Enter name"
                                    disabled={props.modalType === 2}
                                    type="text"
                                    name="name"
                                    onChange={(e) => setLastName(e.target.value)}
                                    value={lastName}
                                />
                                {/* <span className={nameMsg ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">{nameMsg}</label>
                                </span> */}
                            </Form.Group>
                            <Form.Group>
                                <label className=" d-block">User Role <span className="text-danger">*</span></label>
                                <Select
                                    classNamePrefix="triage-select"
                                    placeholder='Select Role'
                                    className="w-100"
                                    name="roleSearch"
                                    options={rolesOptions}
                                    onChange={(e) => setRoleId(e.value)}
                                    value={rolesOptions.filter((r) => r.value === roleId)}
                                    disabled={props.modalType === 2}
                                // isClearable
                                />

                                <span className={roleMsg ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">{roleMsg}</label>
                                </span>
                            </Form.Group>

                            <Form.Group>
                                <label className=''>Email <span className="text-danger">*</span></label>
                                <Form.Control
                                    placeholder="xyz@example.com"
                                    disabled={props.modalType === 2}
                                    type="text"
                                    name="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    required
                                />
                                <span className={emailMsg ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">{emailMsg}</label>
                                </span>

                            </Form.Group>
                            {
                                props.modalType !== 2 ?
                                    <Form.Group>
                                        <Form.Group>
                                            <label className=''>Password <span className="text-danger">{props.modalType === 1 ? '*' : ''}</span></label>
                                            <Form.Control
                                                placeholder="password"
                                                disabled={props.modalType === 2}
                                                type="password"
                                                autoComplete="off"
                                                name="password"
                                                onChange={(e) => setPasssword(e.target.value)}
                                                value={password}
                                                required
                                            />
                                            <span className={passwordMsg ? `` : `d-none`}>
                                                <label className="pl-1 text-danger">{passwordMsg}</label>
                                            </span>
                                        </Form.Group>

                                        <Form.Group>
                                            <label className=''>Confirm Password <span className="text-danger">{props.modalType === 1 ? '*' : ''}</span></label>
                                            <Form.Control
                                                placeholder="confirmPassword"
                                                disabled={props.modalType === 2}
                                                type="password"
                                                autoComplete="off"
                                                name="confirmPassword"
                                                onChange={(e) => setConfirmPass(e.target.value)}
                                                value={confirmPassword}
                                                required
                                            />
                                            <span className={confirmPassMsg ? `` : `d-none`}>
                                                <label className="pl-1 text-danger">{confirmPassMsg}</label>
                                            </span>

                                        </Form.Group>
                                        {
                                            props.modalType === 3 && password && <Form.Group>
                                                <label className=''>Admin Password <span className="text-danger">*</span></label>
                                                <Form.Control
                                                    placeholder="confirmPassword"
                                                    disabled={props.modalType === 2}
                                                    type="password"
                                                    autoComplete="off"
                                                    name="adminPass"
                                                    onChange={(e) => setAdminPassword(e.target.value)}
                                                    value={adminPassword}
                                                    required
                                                />
                                                <span className={adminPasswordMsg ? `` : `d-none`}>
                                                    <label className="pl-1 text-danger">{adminPasswordMsg}</label>
                                                </span>

                                            </Form.Group>
                                        }
                                    </Form.Group>
                                    :
                                    null
                            }

                            <Form.Group>
                                <label className=''>Photo </label>
                                <Form.Control
                                    className=""
                                    placeholder="Image"
                                    type="file"
                                    varient="info"
                                    accept=".png,.jpeg,.jpg"
                                    onChange={(e) => onFileChange(e)}
                                    id="photo"
                                />
                                <span className={photoMsg ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">{photoMsg}</label>
                                </span>
                            </Form.Group>
                            {
                                image &&
                                <Form.Group>
                                    <img src={image} id="imageUploader" className="image-fluid" style={{ width: '30%', height: '30%' }} alt="user-image" />
                                </Form.Group>
                            }
                            {
                                photo && !image && <Form.Group>
                                    <img src={ENV.assetsUrl + "users/" + photo} id="imageUploader" className="image-fluid" style={{ width: '30%', height: '30%' }} alt="user-image" />
                                </Form.Group>
                            }
                            <FormGroup >
                                <label className=''>Status</label>
                                <div className='d-flex align-items-center'>
                                    <label className="right-label-radio mr-3 mb-2">Active
                                        <input name="isActive" disabled={props.modalType === 2} type="radio" checked={isActive} value={isActive} onChange={(e) => setIsActive(1)} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="right-label-radio mr-3 mb-2">Inactive
                                        <input name="isActive" disabled={props.modalType === 2} type="radio" checked={!isActive} value={!isActive} onChange={(e) => setIsActive(0)} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </FormGroup>
                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className="outline-button" onClick={() => onCloseHandler()}>Close</Button>
                        {
                            props.modalType === 2 ? '' :
                                <Button className="btn-filled" onClick={() => submit()} disabled={isAddingStaff || isUpdatingStaff}>Save</Button>
                        }
                    </Modal.Footer>
                </Modal>
            }
        </Container >
    )
}

export default StaffPermissionModal;
